import { useDispatch } from "react-redux";

import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useEffect } from "react";
import KartuStokMinyakMain from "../../features/kartu-stok-minyak/components/kartu-stok-minyak-main";

const title = "Kartu Stok Minyak";

const KartuStokMinyakPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <KartuStokMinyakMain />;
};
export default KartuStokMinyakPage;
